@import "~@orestbida/iframemanager/dist/iframemanager.css";

physiogroup-iframe {
}
